export default __webpack_public_path__ + "static/media/basiercirclemono-regular-webfont.6cf9e79c.ttf";